import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const FormBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 24px;
  padding: 22px;
  align-items: center;

  background: ${(props) => (props.success ? "transparent" : "#d75b3c")};

  transition: background 0.1s ease-out, opacity 0.1s ease-out,
    color 0.1s ease-out;
  &:hover {
    background: ${(props) => (props.success ? "transparent" : "#ed6c45")};
  }
  &:active {
    background: ${(props) => (props.success ? "transparent" : "#d4603d")};
  }
  &:disabled {
    opacity: ${(props) => (props.success ? "1" : "0.3")};
  }
  & svg {
    margin-right: 12px;
    width: 1.75em;
  }
  @media ${breakpoints.sm} {
    margin-top: 24px;
    padding: 21px 0;
  }
`;
export const FormBtnText = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  text-transform: uppercase;
  @media ${breakpoints.sm} {
    font-size: 16px;
  }
`;
